import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { PlayerProvider } from './contexts/PlayerContext';
import { LibraryProvider } from './contexts/LibraryContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useSeedPlaylists } from './hooks/useSeedPlaylists';
import { Sidebar } from './components/Sidebar';
import { MobileNav } from './components/MobileNav';
import { PlayerBar } from './components/PlayerBar';
import { AmbientBackdrop } from './components/AmbientBackdrop';
import { PageTransition } from './components/PageTransition';
import { Home } from './pages/Home';
import { Search } from './pages/Search';
import { Library } from './pages/Library';
import { Playlist } from './pages/Playlist';
import { NowPlaying } from './pages/NowPlaying';
interface AppProps {
  /** Which Three.js treatment drives the audio-reactive scene. */
  visualizerStyle?: 'vinyl' | 'particles';
  /** Show the large reactive scene in the Home hero. */
  showHeroVisualizer?: boolean;
  /** Audio-reactive room light behind the content. */
  ambientBackdrop?: boolean;
}
interface ShellProps {
  visualizerStyle: 'vinyl' | 'particles';
  showHeroVisualizer: boolean;
}
function Shell({
  visualizerStyle,
  showHeroVisualizer
}: ShellProps) {
  const location = useLocation();
  useSeedPlaylists();
  return <AnimatePresence mode="wait" initial={false} data-id="element-0" data-mp="2zld1d7i6tbah">
      <PageTransition key={location.pathname} data-id="element-1" data-mp="2zmo3z3zwcd00">
        <Routes location={location} data-id="element-2" data-mp="33mf3bw3ho1g5">
          <Route path="/" element={<Home visualizerStyle={visualizerStyle} showHeroVisualizer={showHeroVisualizer} data-id="element-4" data-mp="33oi0d0326uud" />} data-id="element-3" data-mp="33nges1of2pye" />
          <Route path="/search" element={<Search data-id="element-6" data-mp="3dl4ktnrh3jvv" />} data-id="element-5" data-mp="3dkuw03i5zirr" />
          <Route path="/now-playing" element={<NowPlaying visualizerStyle={visualizerStyle} data-id="element-8" data-mp="3dii6n5a2u64o" />} data-id="element-7" data-mp="3dmfqxu8e53q5" />
          <Route path="/library" element={<Library data-id="element-10" data-mp="nxww9i4xheu4" />} data-id="element-9" data-mp="nv0zhx4tgw79" />
          <Route path="/playlist/:id" element={<Playlist data-id="element-12" data-mp="stc6m03q8sls" />} data-id="element-11" data-mp="sudoanf90dch" />
        </Routes>
      </PageTransition>
    </AnimatePresence>;
}
export function App({
  visualizerStyle = 'vinyl',
  showHeroVisualizer = true,
  ambientBackdrop = true
}: AppProps) {
  return <BrowserRouter data-id="element-13" data-mp="3uevrrz7vo833">
      <ThemeProvider data-id="element-14" data-mp="d4nwdiwxho3g">
        <LibraryProvider data-id="element-15" data-mp="d57fh2ybeij2">
          <PlayerProvider data-id="element-16" data-mp="d3cw3t2oyyh3">
            <div className="relative flex h-full w-full flex-col overflow-hidden bg-ink-base" data-id="element-17" data-mp="d2l8b4fc651d">
              {ambientBackdrop && <AmbientBackdrop data-id="element-18" data-mp="3gle7gc7darc0" />}
              <div className="relative flex min-h-0 flex-1" data-id="element-19" data-mp="3gklc07duzo96">
                <Sidebar data-id="element-20" data-mp="3gj1w4hw47f7x" />
                <main className="scroll-thin min-w-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain" data-id="element-21" data-mp="3bmtgz4hx3m0r">
                  <Shell visualizerStyle={visualizerStyle} showHeroVisualizer={showHeroVisualizer} data-id="element-22" data-mp="3qc95sexw1hdt" />
                </main>
              </div>
              <div className="relative" data-id="element-23" data-mp="3liefgsns245r">
                <PlayerBar visualizerStyle={visualizerStyle} data-id="element-24" data-mp="2xu3jo3wxuuoc" />
                <MobileNav data-id="element-25" data-mp="2xsk46fj3wnnm" />
              </div>
            </div>
          </PlayerProvider>
        </LibraryProvider>
      </ThemeProvider>
    </BrowserRouter>;
}